<header class="background-header classic-background"></header>
<section class="main-side-nav"
	[ngClass]="{hideOnMobile:sideNavBarVisibilityService.hideOnMobile==true, 'main-side-nave-theme': themeService.theme != 'default' && themeService.theme != 'boosst' && themeService.theme != 'NWRTheme'}"
	*ngIf="showAllUsers == true">
	<section class="container admin-dashboard-parent professionals-container">
		<section class="template-section-title">
			<div class="breadcrumb-container">
				<span>Admin <i class="fa fas fa-chevron-right"></i></span>
				<app-breadcrumb [pageName]="'Professionals'" [isTopLevel]="true"></app-breadcrumb>
			</div>
			<div class="title-container">
				<h1>Professionals</h1>
			</div>
		</section>
		<!-- Search -->
		<section class="all-users-line-presentation">
			<div class="search-section">
				<div class="accounts-number">
					<span>
						<!-- {{users.length}} --> X professionals
					</span>
				</div>
				<div class="buttons-managment">
					<input type="text" class="dashboard-input" placeholder="Firm Name">
					<input type="button" class="btn btn-primary search-btn" value="Search">
					<input type="button" class="btn btn-primary export-btn" value="Export" (click)="exportAsXLSX()">
				</div>
			</div>
		</section>
		<!-- Table data -->
		<section class="all-users-data">
			<div class="table-responsive admin-dashboard-table">
				<table class="table table-borderless table-hover">
					<thead>
						<tr>
							<th scope="col">First Name</th>
							<th scope="col">Last Name</th>
							<th scope="col">Firm Name</th>
							<th scope="col">Email</th>
							<th scope="col">Active Licenses</th>
							<th scope="col">Active</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let dataUser of professionalsUsers" (click)="onSelect(dataUser)">
							<td>{{dataUser.firstName}}</td>
							<td>{{dataUser.lastName}}</td>
							<td>{{dataUser.firm}}</td>
							<td>{{dataUser.email}}</td>
							<td>{{dataUser.active}}</td>
							<td>{{dataUser.license}}</td>
						</tr>
					</tbody>
				</table>
			</div>
		</section>
	</section>
</section>
<app-professionals-details *ngIf="userDetail == true" [dataUser]="selectedUser" (onClick)="backFromDetailUser()">
</app-professionals-details>